<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
                <div slot="header">
                    <h3>
                        <feather-icon icon-pack="feather-icon" icon="SendIcon"></feather-icon>
                        Sandbox
                    </h3>
                </div>
                <div>
                    <form @submit.prevent="sendRequest()">
                        <vs-row vs-w="12">
                            <vs-col vs-w="12">
                                <vs-select @change="selectObj" v-model="selected_interface" width="100%" autocomplete placeholder="Choose one" class="selectExample" label="Interface">
                                    <vs-select-item :key="index" :value="item.token" :text="item.title" v-for="(item,index) in interfaces"/>
                                </vs-select>
                                <span class="text-danger text-sm" v-show="errors.has('interfaces')">{{ errors.first('selected_interfaces') }}</span>
                            </vs-col>
                        </vs-row>
                        <vs-row v-if="selected_interface_obj" vs-w="12">
                            <vs-col vs-w="12">
                                <vs-list>
                                    <vs-list-item title="Description:" :subtitle="selected_interface_obj.description"></vs-list-item>
                                    <vs-list-item title="API Key:" :subtitle="selected_interface_obj.token"></vs-list-item>
                                    <vs-list-item title="Secret Key:" :subtitle="this.$store.state.AppActiveUser.data.user.token"></vs-list-item>
                                </vs-list>
                            </vs-col>
                        </vs-row>
                        <vs-row v-if="selected_interface_obj" vs-w="12">
                            <vs-col vs-w="12">
                                <vs-divider><b>Usage</b></vs-divider>
                            </vs-col>
                            <vs-col v-for="obj in selected_interface_obj.vars" vs-w="4">
                                <vs-input style="width: 100%;" :label="obj.title" v-model="obj.value"/>
                            </vs-col>
                        </vs-row>
                        <vs-row v-if="selected_interface_obj" vs-w="12">
                            <vs-col vs-w="12">
                                <pre class='code code-html'><label>URL</label>
                                    <code style="background: #333;">{{getURL}}</code>
                                </pre>
                            </vs-col>
                        </vs-row>
                        <br>
                        <vs-row v-if="selected_interface_obj" vs-w="12">
                            <vs-col vs-w="12">
                                <vs-button style="float:right;" ref="loadableButton" id="button-with-loading" class="vs-con-loading__container" type="relief" vslor="primary">
                                    Send a request
                                </vs-button>
                            </vs-col>
                        </vs-row>
                        <br>
                        <vs-row v-if="data_errors" vs-w="12">
                            <vs-col vs-w="12">
                                <vs-alert color="danger" title="Errors" active="true">
                                    <span v-for="error in data_errors">{{error}}<br></span>
                                </vs-alert>
                            </vs-col>
                        </vs-row>
                        <vs-row v-if="response" vs-w="12">
                            <vs-col vs-w="12">
                                <vs-alert color="success" title="Response" active="true">
                                    <span>{{response}}</span>
                                </vs-alert>
                            </vs-col>
                        </vs-row>
                    </form>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
</template>


<script>

    import Configs from '../../config.js';
    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    import loadsh from 'lodash/lodash';

    export default {
        data() {
            return {
                selected_interface: null,
                interfaces: [],
                selected_interface_obj: null,
                data_errors: null,
                response:null
            }
        },
        components: {
            FormWizard,
            TabContent
        },
        created() {
            this.setBreadCrumbsItems();
            this.getInterfaces();
        },
        computed: {
            getURL: function () {
                let vars = this.selected_interface_obj.base_url + "/api/v1/sandbox/" + "?api_key=" + this.selected_interface_obj.token + "&secret_key=" + this.$store.state.AppActiveUser.data.user.token;
                this.selected_interface_obj.vars.forEach(function (item, index) {
                    if (item.value) {
                        vars += "&" + item.title + "=" + item.value;
                    } else {
                        vars += "&" + item.title + "=";
                    }
                });
                return vars;
            }
        },
        methods: {
            sendRequest() {
                this.$vs.loading({background: "primary", color: "#fff", container: "#button-with-loading", scale: 0.45});
                Window.axios({
                    method: 'get',
                    url: this.getURL,
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                    }
                }).then((response) => {
                    this.response = response.data;
                    this.data_errors = null;
                    this.$vs.loading.close("#button-with-loading > .con-vs-loading")
                }).catch((err) => {
                    this.response = null;
                    this.$vs.loading.close("#button-with-loading > .con-vs-loading")
                    this.data_errors = err.response.data;
                })
            },
            selectObj() {
                let token = this.selected_interface;
                this.selected_interface_obj = _.find(this.interfaces, function (o) {
                    return o.token === token;
                });
            },
            getInterfaces() {
                this.loader = true;
                this.$vs.loading();
                Window.axios({
                    method: 'post',
                    url: Configs.host + '/api/v1/sandbox/get-interfaces',
                    data: {},
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + this.$store.state.AppActiveUser.token
                    }
                }).then((response) => {
                    this.interfaces = response.data;
                    this.loader = false;
                    this.$vs.loading.close();
                }).catch((err) => {
                    console.log(err.response);
                    this.loader = false;
                    this.$vs.loading.close();
                })
            },
            setBreadCrumbsItems() {
                let items = [
                    {
                        title: 'Sandbox',
                        active: true
                    }
                ];
                this.$store.commit("SetBreadCrumbsItems", items)
            }
        }
    }
</script>

<style>
    .pagination-bar {
        display: none;
    }

    .options {
        margin: 1px !important;
        display: inline-flex !important;
    }

    /* CSS Simple Pre Code */
    pre {
        background: #333;
        white-space: pre;
        word-wrap: break-word;
        overflow: auto;
    }

    pre.code {
        margin: 20px 25px;
        border-radius: 4px;
        border: 1px solid #292929;
        position: relative;
    }

    pre.code label {
        font-family: sans-serif;
        font-weight: bold;
        font-size: 13px;
        color: #ddd;
        position: absolute;
        left: 1px;
        top: 15px;
        text-align: center;
        width: 60px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        pointer-events: none;
    }

    pre.code code {
        font-family: "Inconsolata", "Monaco", "Consolas", "Andale Mono", "Bitstream Vera Sans Mono", "Courier New", Courier, monospace;
        display: block;
        margin: 0 0 0 60px;
        padding: 15px 16px 14px;
        border-left: 1px solid #555;
        overflow-x: auto;
        font-size: 13px;
        line-height: 19px;
        color: #ddd;
    }

    pre::after {
        content: "double click to selection";
        padding: 0;
        width: auto;
        height: auto;
        position: absolute;
        right: 18px;
        top: 14px;
        font-size: 12px;
        color: #ddd;
        line-height: 20px;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        transition: all 0.3s ease;
    }

    pre:hover::after {
        opacity: 0;
        visibility: visible;
    }

    pre.code-css code {
        color: #91a7ff;
    }

    pre.code-html code {
        color: #aed581;
    }

    pre.code-javascript code {
        color: #ffa726;
    }

    pre.code-jquery code {
        color: #4dd0e1;
    }
</style>